import { render } from "./ContentBox.vue?vue&type=template&id=e57e2ad4&ts=true"
import script from "./ContentBox.vue?vue&type=script&lang=ts"
export * from "./ContentBox.vue?vue&type=script&lang=ts"

import "./ContentBox.vue?vue&type=style&index=0&id=e57e2ad4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__